import { createMutationHook, createQueryHook } from '@/common/hooks/typedHookFactory';
import { QueryKeys } from '@/common/queryKeys';
import { graphql } from '@/generated/graphql';

const UPDATE_DISTRICT_LOADFACTOR = graphql(`
  mutation UpdateDistrictLoadFactor($loadFactor: Int, $districtId: String) {
    update_district(where: { id: { _eq: $districtId } }, _set: { loadFactor: $loadFactor }) {
      affected_rows
      returning {
        departments_districts {
          departmentId
        }
      }
    }
  }
`);

const UPDATE_DISTRICT_DELIVERYDAYS = graphql(`
  mutation UpdateDistrictDeliveryDays($deliveryDays: Int, $districtId: String) {
    update_district(where: { id: { _eq: $districtId } }, _set: { deliveryDays: $deliveryDays }) {
      affected_rows
      returning {
        departments_districts {
          departmentId
        }
      }
    }
  }
`);

const UPDATE_DISTRICT_OFFDAYS = graphql(`
  mutation UpdateDistrictOffDays($offDays: jsonb, $districtId: String) {
    update_district(where: { id: { _eq: $districtId } }, _set: { offDays: $offDays }) {
      affected_rows
      returning {
        departments_districts {
          departmentId
        }
      }
    }
  }
`);

const GET_DISTRICTS_DRIVER_LIST = graphql(`
  query GetDistrictsDriverList($departmentId: Int!, $searchTerm: String) {
    district(
      where: {
        departments_districts: { departmentId: { _eq: $departmentId } }
        name: { _ilike: $searchTerm }
      }
    ) {
      loadFactor
      deliveryDays
      id
      enabled
      name
      offDays
      cutoffHours
      isPolygone
      district_delivery_providers {
        delivery_provider_id
      }
      weekday_window_districts {
        weekday_window {
          driver_window {
            driverId
            id
            user {
              blocked
              name
            }
          }
        }
      }
    }
  }
`);

const UPDATE_CUTOFF_HOURS = graphql(`
  mutation UpdateCutoffHours($districtId: String!, $hours: Int!) {
    update_district_by_pk(pk_columns: { id: $districtId }, _set: { cutoffHours: $hours }) {
      id
    }
  }
`);

export const useUpdateCutoffHours = createMutationHook(UPDATE_CUTOFF_HOURS, {
  invalidateQueries: [
    {
      queryKey: () => [QueryKeys.GET_DISTRICTS_DRIVER_LIST],
    },
  ],
  errorMessage: 'Error updating cutoff hours',
});

export const useGetDistrictsDriverList = createQueryHook(GET_DISTRICTS_DRIVER_LIST, (variables) => [
  QueryKeys.GET_DISTRICTS_DRIVER_LIST,
  variables.departmentId,
  variables.searchTerm,
]);

const GET_AVAILABLE_PROVIDERS = graphql(`
  query GetAvailableProviders($countryId: String!) {
    delivery_provider(where: { is_external: { _eq: false }, country_code: { _eq: $countryId } }) {
      id
      short_name
      display_name
    }
  }
`);

export const useGetAvailableProviders = createQueryHook(
  GET_AVAILABLE_PROVIDERS,
  (variables) => [QueryKeys.GET_AVAILABLE_PROVIDERS, variables.countryId],
  {
    enabled: (variables) => Boolean(variables.countryId),
    staleTime: 5 * 60 * 1000,
  }
);

const CHANGE_DISTRICT_PROVIDERS = graphql(`
  mutation ChangeDistrictProviders($districtId: String!, $providers: [uuid!]!) {
    changeDistrictProviders(districtId: $districtId, providers: $providers) {
      applied
    }
  }
`);

export const useChangeDistrictProviders = createMutationHook(CHANGE_DISTRICT_PROVIDERS, {
  invalidateQueries: [
    {
      queryKey: () => [QueryKeys.GET_DISTRICTS_DRIVER_LIST],
    },
  ],
  errorMessage: 'Error updating district providers',
});

export const useUpdateDistrictLoadFactor = createMutationHook(UPDATE_DISTRICT_LOADFACTOR, {
  invalidateQueries: [
    {
      queryKey: () => [QueryKeys.GET_DISTRICTS_DRIVER_LIST],
    },
  ],
  errorMessage: 'Error updating district load factor',
});

export const useUpdateDistrictDeliveryDays = createMutationHook(UPDATE_DISTRICT_DELIVERYDAYS, {
  invalidateQueries: [
    {
      queryKey: () => [QueryKeys.GET_DISTRICTS_DRIVER_LIST],
    },
  ],
  errorMessage: 'Error updating district delivery days',
});

export const useUpdateDistrictOffDays = createMutationHook(UPDATE_DISTRICT_OFFDAYS, {
  invalidateQueries: [
    {
      queryKey: () => [QueryKeys.GET_DISTRICTS_DRIVER_LIST],
    },
  ],
  errorMessage: 'Error updating district off days',
});
